/**
 * Single source of truth for the three device states (online / connecting /
 * offline). McpDevicesList (Radix Badge, `var(--green-9)` etc.) and
 * DevicesPage (custom dashboard tokens, `var(--dc-success)` etc.) render
 * different color systems, so this exports the semantic category — each
 * caller maps that to its own palette — rather than a single hardcoded color,
 * which is exactly how the two device lists drifted apart before: one of
 * them lost the "connecting" case entirely when it was rewritten.
 */
export type DeviceStatusCategory = "success" | "warning" | "neutral";

export function deviceStatusLabel(status: string): string {
    if (status === "online") {
        return "Online";
    }
    if (status === "connecting") {
        return "Connecting";
    }
    return "Offline";
}

export function deviceStatusCategory(status: string): DeviceStatusCategory {
    if (status === "online") {
        return "success";
    }
    if (status === "connecting") {
        return "warning";
    }
    return "neutral";
}
